<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="submission-changes-container">
      <app-investment-instruction-submission-instruction-changes
        [submission]="submission.investmentInstructionSubmission" />
      <app-investment-instruction-submission-allocation-changes
        [submission]="submission.investmentInstructionSubmission" />
    </div>
    <hr class="m-0" />
    <app-submission-submitted-file-list [files]="submission.attachments" />
    <ng-content />
  </div>
</div>
